@if (!showOnlyTitle) {
  <span class="text-error! pb-0! indent-0!" matDialogTitle>{{ data.title }}</span>
}
<button mat-icon-button matDialogClose (click)="close()">
  <mat-icon> close </mat-icon>
</button>

<mat-dialog-content>
  @if (!showOnlyTitle) {
    {{ data.message }}
  } @else {
    <div class="text-error! w-full text-2xl">{{ data.title }}</div>
  }
</mat-dialog-content>

@if (!showOnlyTitle && !isInternal) {
  <div matDialogActions align="end" class="gap-1">
    <button (click)="copyMessageToClipboard()" mat-button class="primary small">
      <mat-icon>content_copy</mat-icon>
      {{ 'Copia errore' | siaTranslate }}
    </button>
    @if (emailString) {
      <button mat-button class="primary small" (click)="openEmail()">
        <mat-icon>email</mat-icon>
        <span>{{ 'Contatta supporto' | siaTranslate }}</span>
      </button>
    }
  </div>
}
